import type { Question, WithContext } from 'schema-dts';

import type { FAQNodeProps } from '.';

/**
 * Helper function to get the structured data for an FAQ node.
 *
 * @param page - The payload of an FAQ node.
 *
 * @returns The structured data for the FAQ node.
 *
 * @see https://developers.google.com/search/docs/appearance/structured-data/faqpage#question
 * @see https://schema.org/Question
 */

const getFAQStructuredData = ({ question, answer }: FAQNodeProps) => {
  const structuredData: WithContext<Question> = {
    '@context': 'https://schema.org',
    '@type': 'Question',
    name: question,
    text: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  };

  return structuredData;
};

export default getFAQStructuredData;
